import axios from 'axios';
import Cookies from 'js-cookies';

export default {
  install(Vue, { config }) {
    const axiosInstance = axios.create({
      baseURL: config.baseURL,
      headers: {
        Authorization: `Bearer ${Cookies.getItem('wwwila_access_token')}`,
        common: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }
    });

    Vue.prototype.$wiswiseproxyclient = {
      async get(payload, config) {
        try {
          // await sleep(3000);
          return await axiosInstance.get('/api/app/wis-wise-proxy', config);
        } catch (error) {
          if (error.response.status === 401) window.location.reload();
          notify(Vue, error.response.data);
          throw error;
        }
      },
      async post(payload, config) {
        try {
          // await sleep(3000);
          return await axiosInstance.post(
            '/api/app/wis-wise-proxy',
            payload,
            config
          );
        } catch (error) {
          if (error.response.status === 401) window.location.reload();
          notify(Vue, error.response.data);
          throw error;
        }
      }
    };
  }
};

function notify(Vue, data) {
  if (Vue.prototype.$notify) {
    for (const error of data.errors) {
      Vue.prototype.$notify({
        duration: error.duration,
        message: error.message ?? error.error_code ?? 'Unknown error',
        severity: error.severity
      });

      if (error.field) {
        const el = document.getElementById(error.field);
        if (el) el.scrollIntoView();
      }
    }
  }
}

// eslint-disable-next-line no-unused-vars
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
